import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import AppRoot from './app/AppRoot';
import { initYandexMetrika } from './shared/lib/metrika';

initYandexMetrika();

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <AppRoot />
  </StrictMode>,
);
